/**
 * Shared predicates for filtering questionnaire rounds (`IssbQuestionnaire`) in selectors.
 */

/**
 * True for either Foundation Data round — v1 (`foundationRound`) or v2 (`foundationRoundV2`).
 *
 * Both have their own dedicated page and must be hidden from every round selector. There are five such
 * places, and before this helper each tested `round.foundationRound` inline — which meant adding v2
 * required finding all five, and missing one would leak the v2 round into a picker where selecting it
 * does something undefined. A third round type should only ever need to change this function.
 *
 * Deliberately not `useAirUserRoles().isFoundationRound`, which is v1-specific (as its name says),
 * currently unused, and only available inside a hook — these call sites are plain array filters.
 *
 * @param {{foundationRound?: boolean, foundationRoundV2?: boolean}} round
 * @returns {boolean}
 */
export const isFoundationLikeRound = (round) =>
  round?.foundationRound === true || round?.foundationRoundV2 === true;

export default isFoundationLikeRound;
